export const cartSummaryOptions = {
    thisIsCartSummaryHandler: '.thisIsCartSummary--js',
    adPreviewImageHandler: '.ad-preview__image--js',
}